export default {
  resorder_details: "تفاصيل الطلب",
  resback: "رجوع",

  resorder_id: "رقم الطلب",
  resorder_date: "تاريخ الطلب",
  ressupplier: "المورد",
  restotal_amount: "إجمالي المبلغ",

  resrestaurant_details: "تفاصيل المطعم",
  ressupplier_details: "تفاصيل المورد",

  resname: "الاسم",
  rescontact: "جهة الاتصال",
  resmobile: "الجوال",
  resemail: "البريد الإلكتروني",
  resaddress: "العنوان",

  resdelivery_details: "تفاصيل التوصيل",
  resdelivery_completed: "تم التوصيل",

  resdelivery_type: "نوع التوصيل",
  resdriver: "السائق",
  resdriver_mobile: "جوال السائق",
  resvehicle_type: "نوع المركبة",
  resvehicle_number: "رقم المركبة",
  resvehicle: "المركبة",
  respartner: "الشريك",
  resestimated_arrival: "وقت الوصول المتوقع",

  resrecurring_schedule: "الطلب المتكرر",
  resfrequency: "التكرار",
  resdays: "الأيام",
  resstart_date: "تاريخ البداية",
  resend_date: "تاريخ النهاية",
  resnext_run: "التشغيل التالي",
  resstatus: "الحالة",

  resorder_items: "عناصر الطلب",
  resitem: "الصنف",
  resqty: "الكمية",
  resprice: "السعر",

  restrack_order: "تتبع الطلب",
  ressubmit_review: "إرسال التقييم",
  resreport_issue: "الإبلاغ عن مشكلة",
  resview_invoice: "عرض الفاتورة",
  rescreate_grn: "إنشاء / عرض GRN",

  resplaced: "تم الطلب",
  resconfirmed: "تم التأكيد",
  resdelivered: "تم التوصيل",
  rescancelled: "ملغي",
  resout_for_delivery: "قيد التوصيل",
  resshopno:"رقم المحل",
  reszone:"منطقة",
  resshop_no: "رقم المحل",
  reszone: "المنطقة",
};